import type { ResponseMetrics } from '../types';

interface MetricsDisplayProps {
  metrics: ResponseMetrics;
  modelDisplayName: string;
}

export default function MetricsDisplay({
  metrics,
  modelDisplayName,
}: MetricsDisplayProps) {
  return (
    <div className="metrics-display">
      <span className="metrics-display-model">{modelDisplayName}</span>
      <span className="metrics-display-timing">
        <span className="metrics-display-ttft">
          TTFT: {metrics.ttftMs}ms
        </span>
        <span className="metrics-display-total">
          Total: {metrics.totalMs}ms
        </span>
      </span>
      <span className="metrics-display-tokens">
        <span className="metrics-display-input-tokens">
          Input: {metrics.inputTokens}
        </span>
        <span className="metrics-display-output-tokens">
          Output: {metrics.outputTokens}
        </span>
        <span className="metrics-display-total-tokens">
          Total: {metrics.totalTokens}
        </span>
      </span>
      <span className="metrics-display-cost">
        Cost: &lt;{metrics.estimatedCostUsd.toFixed(6)}
      </span>
    </div>
  );
}
